import appGlobalScript from '/home/runner/work/jllt-cm-solstice-platform/jllt-cm-solstice-platform/packages/sol-stencil/src/global/js/mode-config.ts';
export const globalScripts = appGlobalScript;
